export default "__VITE_ASSET__Ca7MswPH__"